{
  "glyphs": {
    "lesserThan": "<",
		"hashtag": "#",
		"ampersand": "&",
		"openRoundParentheses": "(",
		"exclamation": "!",
		"closeRoundParentheses": ")",
		"degrees": "°",
		"hyphen": "-",
		"underscore": "_",
		"circumflex": "^",
		"multiply": "*",
		"percent": "%",
		"colon": ":",
		"forwardSlash": "/",
		"semiColon": ";",
		"dot": ".",
		"comma": ",",
		"questionMark": "?",
		"plus": "+",
		"equal": "=",
		"largerThan": ">",
		"0": "0",
		"1": "1",
		"2": "2",
		"3": "3",
		"4": "4",
		"5": "5",
		"6": "6",
		"7": "7",
		"8": "8",
		"9": "9"
  }
}
